import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import UploadGalleryModal from "pages/de/portfolio/components/UploadGalleryModal";

import { AccountContext } from "context/account";
import api from "services/api";
import toast from "react-hot-toast";

const AddGalleryCard = ({
  content = null,
  handleOk,
  sx = {},
  slot,
  handleRefresh = () => {},
  ...rest
}) => {
  const [uploadGalleryVisible, setUploadGalleryVisible] = useState(false);

  return (
    <SuiBox
      sx={{
        border: "1px dashed",
        borderWidth: ({ borders }) => borders.borderWidth[2],
        borderColor: ({ borders }) => borders.borderColor,
        cursor: "pointer",
        height: 120,
        width: "100%",
        borderRadius: 4,
        ...sx,
      }}
      {...rest}
    >
      {content ? (
        content
      ) : (
        <SuiBox
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ height: "100%", width: "100%", cursor: "pointer" }}
          onClick={() => setUploadGalleryVisible(true)}
        >
          <AddIcon fontSize="small" />
          <SuiTypography variant="body2" textTransform="uppercase" fontWeight="bold">
            Add Image/Video
          </SuiTypography>{" "}
        </SuiBox>
      )}
      {uploadGalleryVisible ? (
        <UploadGalleryModal
          handleClose={() => setUploadGalleryVisible(false)}
          visible={uploadGalleryVisible}
          handleRefresh={() => {
            handleRefresh();
          }}
        />
      ) : null}
    </SuiBox>
  );
};

export default AddGalleryCard;
